import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../components/Button";
import ConfirmModal from "../../components/ConfirmModal";
import * as Fonts from "../../components/Fonts";
import { TextArea } from "../../components/Form/Input/textArea";
import Label from "../../components/Form/Label";
import { FormGroup } from "../../components/Form/styles";
import { ScreenHeader } from "../../components/SubHeader";
import { api } from "../../services/api";
import { Rating } from "./components/Rating";
import { Card, CardFooter, Container, Divider, Section } from "./styles";

export const FeedbackPage = () => {
  const { t } = useTranslation();

  const [message, setMessage] = useState("");
  const [value, setValue] = useState(5);

  const [isSubmitting, setSubmitting] = useState(false);
  const [isSubmitted, setSubmitted] = useState(false);

  // Thanks the user and stays on the screen, ready for another feedback
  const closeSuccessModal = () => {
    setSubmitted(false);
    setMessage("");
    setValue(5);
  };

  const submitHandler = async () => {
    setSubmitting(true);
    try {
      await api.submitFeedback(value, message);
    } finally {
      setSubmitting(false);
      setSubmitted(true);
    }
  };

  return (
    <Container>
      <ScreenHeader
        title={t("pages.feedback.header.title")}
        mobileBack={{ label: t("pages.account.header.title"), to: "/account" }}
      />
      <Section>
        <Fonts.Label>{t("pages.feedback.sections.experience")}</Fonts.Label>
        <Card>
          <Rating value={value} onSelect={setValue} />
          <Divider />
          <FormGroup>
            <TextArea
              id="message"
              name="message"
              autoComplete="off"
              rows={5}
              maxLength={1000}
              value={message}
              //@ts-ignore
              onChange={e => setMessage(e.target.value)}
            />
            <Label
              htmlFor="message"
              text={t("pages.feedback.form.message")}
              maxLength={1000}
              usedLength={message.length}
            />
          </FormGroup>
          <CardFooter>
            <Button size="MD" type="INFO" onClick={submitHandler} disabled={isSubmitting}>
              {t("pages.feedback.form.save")}
            </Button>
          </CardFooter>
        </Card>
      </Section>
      {isSubmitted && (
        <ConfirmModal
          type="INFO"
          title={t("pages.feedback.successModal.message")}
          confirmButtonTitle={t("pages.feedback.successModal.buttonTitle")}
          onConfirm={closeSuccessModal}
          onExit={closeSuccessModal}
        />
      )}
    </Container>
  );
};
